module.exports = { src: __webpack_public_path__ + "media/cool.165a0654.svg", width: 229, height: 218 };